import { animate, utils } from 'animejs';

export const animateOffersCards = (serviceId: number) => {
  const offers = utils.$('div[data-name="phoneOffer"]');

  switch (serviceId) {
    case 1:
      animate(offers[0], {
        x: 0,
        y: 0,
      });
      animate(offers[1], {
        x: 0,
        y: 0,
      });
      animate(offers[2], {
        x: 100,
        y: 0,
      });
      animate(offers[3], {
        x: -100,
        y: 0,
      });
      break;
    case 2:
      animate(offers[0], {
        x: 0,
        y: 0,
      });
      animate(offers[1], {
        x: -100,
        y: 117,
      });
      animate(offers[2], {
        x: 100,
        y: 0,
      });
      animate(offers[3], {
        x: 0,
        y: -117,
      });
      break;
    case 3:
      animate(offers[0], {
        x: 100,
        y: 0,
      });
      animate(offers[1], {
        x: -100,
        y: 117,
      });
      animate(offers[2], {
        x: 100,
        y: 0,
      });
      animate(offers[3], {
        x: -100,
        y: -117,
      });
      break;
    default:
      animate(offers, {
        x: 0,
        y: 0,
      });
      break;
  }
};
